import { ContactLogDialog } from 'legacy/lut/components/widgets/public/contactLogButton/ContactLogDialog'
import React from 'react'

import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { Actions } from 'core-components/library/modalDialog'

import styles from './ContactLogButton.module.scss'

export const ContactLogButton = (props: any) => {
  const [showDialog, setShowDialog] = React.useState(false)

  return (
    <div className={styles.root}>
      <div>
        <Button onClick={() => setShowDialog(true)}>Audit trail</Button>

        <ModalDialog
          show={showDialog}
          onClose={() => setShowDialog(false)}
          size={'xl'}
          content={ContactLogDialog}
          contentProps={{
            contactID: props.contactID,
            onClose: () => setShowDialog(false),
          }}
          title={'Audit trail'}
          header={() => (
            <Actions
              position={'end'}
              items={[
                {
                  id: 'close',
                  label: 'OK',
                  onClick: () => setShowDialog(false),
                },
              ]}
            />
          )}
        />
      </div>
    </div>
  )
}
